import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ControlFormsService } from '@services/control-forms.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

const AVATAR = 'data:image/jpeg;base64,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'

const MAX_HEIGHT = 300;
const MAX_WIDTH = 300;

@Component({
  selector: 'app-control-imagen',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss']
})
export class ImagePickerComponent implements OnInit {

  @Input()
  set imageData(image: string) {
    if (image) {
      fetch(image)
      .then( (response: Response) => {
        const index = response.url.lastIndexOf('/');
        const imageName = response.url.slice(index + 1);
        return response.blob().then( dataBlob => ({blob: dataBlob, name: imageName}) );
    } )
    .then( data => this.uploadImage( new File( [data.blob], data.name ) ) )
    .then( imagen => this._imageData = imagen )
      
    } else {
      this._imageData = AVATAR;
    }
    //this._imageData = image ? image : AVATAR;
  }

  get imageData(): string { return this._imageData; }

  @Input()
  set maxHeight(value: number) {
    this._maxHeight = value ? value : MAX_HEIGHT;
  }

  @Input()
  set maxWidth(value: number) {
    this._maxWidth = value ? value : MAX_WIDTH;
  }

  @Input() hidding: boolean = false;



  @Output() imageDataReturned = new EventEmitter<string>();

  private _imageData: string = AVATAR;
  private _maxHeight: number = MAX_HEIGHT;
  private _maxWidth: number = MAX_WIDTH;

  private _finisher = new Subject<void>();

  constructor(
    private _controlFormsService: ControlFormsService,

  ) { 
    this._controlFormsService.itemValueImagePicker.pipe(takeUntil(this._finisher)).subscribe((nextValue) => {
      if(!nextValue){
        this.hidding = true;
      }
    });   
  }

  ngOnInit() {
  }

  triggerImageUpload(data: HTMLInputElement): void {
    data.click();
  }

  inputChange(imageFile: File): void {
    if (imageFile) {
      this.uploadImage(imageFile)
        .then( i => {
          this.imageData = i;
          this.imageDataReturned.emit(i);
        })
    }
  }

  private uploadImage(image: File): Promise<string> {
    return new Promise( (acept, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(image);
      fileReader.onload = () => {
        this.scaleImage(fileReader.result as string).then( imgModificada => acept(imgModificada) )
      };
      fileReader.onerror = (error) => reject(error);
    });
  }

  // Reescala el tamaño seleccionado según los valores suministrados
  private scaleImage( image: string ): Promise<string> {
    return new Promise( (acept, reject) => {
      const canvas: HTMLCanvasElement = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.src = image;
      img.onload = () => {

        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > this._maxWidth) {
            const aspectRatio = height / width;
            height = this._maxWidth * aspectRatio;
            width = this._maxWidth;
          }
        } else {
          if (height > this._maxHeight) {
            const aspectRatio = width / height;
            height = this._maxHeight;
            width = this._maxHeight * aspectRatio;
          }
        }
        canvas.height = height;
        canvas.width = width;
        ctx.drawImage(img, 0, 0, width, height);
        const imageText = canvas.toDataURL('image/jpeg', 0.8);
        acept(imageText);

      };
      img.onerror = () => reject('Error en reescalado de imagen');

    } );
  }


}
